import { render, staticRenderFns } from "./repair-detail-paidan-view.vue?vue&type=template&id=012c5f58&scoped=true&"
import script from "./repair-detail-paidan-view.vue?vue&type=script&lang=js&"
export * from "./repair-detail-paidan-view.vue?vue&type=script&lang=js&"
import style0 from "./repair-detail-paidan-view.vue?vue&type=style&index=0&id=012c5f58&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "012c5f58",
  null
  
)

component.options.__file = "repair-detail-paidan-view.vue"
export default component.exports